import { render, staticRenderFns } from "./KaiJiangShow.vue?vue&type=template&id=2794ef4c&scoped=true"
import script from "./KaiJiangShow.vue?vue&type=script&lang=js"
export * from "./KaiJiangShow.vue?vue&type=script&lang=js"
import style0 from "./KaiJiangShow.vue?vue&type=style&index=0&id=2794ef4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1b3fe109433f9fe6108f2b5a977879df/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2794ef4c",
  null
  
)

export default component.exports